export default "__VITE_ASSET__c845074a__"